import css from 'styled-jsx/css';

export default css`
  .tags-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
  }
  @media (max-width: 768px) {
    .tags-wrapper {
      flex-wrap: wrap;
    }
  }
`;
